const formatNumber = (number, decimalSigns = 2, withSpaces = true) => {
  const numberConverted = Number(number);

  if (isNaN(Number(numberConverted)) || numberConverted === null) return '-';

  if (withSpaces) {
    return Number(numberConverted).toLocaleString('ru-RU', { minimumFractionDigits: decimalSigns }).replace(',', '.');
  }

  return Number(numberConverted).toLocaleString('en-US', { minimumFractionDigits: decimalSigns });
}

export default formatNumber;
